import React, { useState } from 'react';
import './BooksPersonalizados.css';

const BooksPersonalizados = () => {
  const [nombre, setNombre] = useState('');
  const [especificacion, setEspecificacion] = useState('');
  const [hoverBook, setHoverBook] = useState(false);
  const [hoverFoto, setHoverFoto] = useState(false);

  const handleWhatsAppRedirect = () => {
    const mensaje = `Hola! Quisiera consultar por el servicio de *Books Personalizados*.\n\nMi nombre es: ${nombre}\n\nEspecificaciones: ${especificacion}`;
    const url = `https://wa.me/5491160035550?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };
    const backgroundStyle = {
    backgroundImage: 'url("/images/fondo-libros.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    position: 'relative',
    width: '100%',
    height: '100%',
  };

  return (
    <div style={backgroundStyle}>
      <div style={{
        backgroundColor: 'rgba(237, 232, 227, 0.85)',
        backdropFilter: 'blur(1px)',
        minHeight: '100vh',
        paddingBottom: '2rem',
      }}>
      <div className="books-header">
        <h1 className="books-title">Books personalizados</h1>
        <p className="books-description">
          Creamos libros únicos y personalizados con tus recuerdos más valiosos. Nos encargamos de organizar y diseñar tus fotos en un formato elegante y listo para imprimir. Perfecto para regalos, viajes o recuerdos familiares.
        </p>
      </div>

      <div className="imagen-descentrada">
          <img
            src={hoverBook ? "/images/book-personalizado.png" : "/images/blank-book-personalizado.jpg"}
            alt="Libro personalizado"
            onMouseEnter={() => setHoverBook(true)}
            onMouseLeave={() => setHoverBook(false)}
            onFocus={() => setHoverBook(true)}     // accesibilidad teclado
            onBlur={() => setHoverBook(false)}
          />
        </div>

      <div className="imagen-descentrada2">
           <img
            src={hoverFoto ? "/images/fotolibro.png" : "/images/blank-fotolibro.jpg"}
            alt="Fotolibro"
            onMouseEnter={() => setHoverFoto(true)}
            onMouseLeave={() => setHoverFoto(false)}
            onFocus={() => setHoverFoto(true)}
            onBlur={() => setHoverFoto(false)}
          />
        </div>

      <div className="books-container">
        <div className="books-pasos">
          <h2>¿Cómo funciona?</h2>
          <div className="pasos-grid">
            <div className="paso">
              <span className="paso-num">1</span>
              <p>Nos mandás tus fotos y una breve descripción</p>
            </div>
            <div className="paso">
              <span className="paso-num">2</span>
              <p>Diseñamos una propuesta de maquetación</p>
            </div>
            <div className="paso">
              <span className="paso-num">3</span>
              <p>Revisás y aprobás el diseño</p>
            </div>
            <div className="paso">
              <span className="paso-num">4</span>
              <p>Imprimimos y te lo entregamos en mano o por correo</p>
            </div>
          </div>
        </div>

        <div className="books-cta-final">
          <h2>¿Querés conservar tus recuerdos de una forma especial?</h2>
          <p>Convertí tus fotos en un libro impreso con diseño profesional.</p>
          <div className="books-form">
            <input
              type="text"
              placeholder="Tu nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
            <textarea
              rows="4"
              placeholder="Contanos qué tipo de book querés"
              value={especificacion}
              onChange={(e) => setEspecificacion(e.target.value)}
            ></textarea>
            <button onClick={handleWhatsAppRedirect}>Consultá por el servicio</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default BooksPersonalizados;
